var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"title is-2"},[_vm._v("\n    Page can't be found.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }